/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div[_ngcontent-%COMP%]{display:flex;align-items:center;flex-direction:column;background-color:rgba(0,0,0,.5);padding:1em;border-radius:1em}div[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{color:rgba(255,255,255,.8)}div[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]:first-child{font-size:3em;display:none}div[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]:last-child{font-size:1.5em;line-height:1.5em}"];
export { styles as styles };
